import { render } from "./AboutMe.vue?vue&type=template&id=3be5c74a&scoped=true"
import script from "./AboutMe.vue?vue&type=script&lang=js"
export * from "./AboutMe.vue?vue&type=script&lang=js"

import "./AboutMe.vue?vue&type=style&index=0&id=3be5c74a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3be5c74a"

export default script